module.exports = __webpack_public_path__ + "1bc250dc1ab7e7d6f056c17e97278558.svg";